<template>
  <div
    class="parallax-image"
    ref="refRoot"
    :class="[full ? 'full' : 'relative']"
  >
    <div
      class="parallax"
      ref="refParallax"
    >
      <div class="scale">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import {pinSafe} from '@/helpers/Gsap'

const { $gsap, $ScrollTrigger } = useNuxtApp()

const props = defineProps({
  full: {
    default: false,
  },
  scale: {
    default: 1.2,
  },
  amount: {
    default: 15,
  },
})
const emits = defineEmits([])

const { app, debug, browser } = useStores()

const refRoot = ref(null)
const refParallax = ref(null)

const hasInited = ref(false)

// **********************************************************************
// PARALLAX
// **********************************************************************

const scroller = inject("scroller")

const createParallax = function () {
  let tl = new $gsap.timeline({
    id: "parallax-image",
    scrollTrigger: {
      trigger: refRoot.value,
      start: `top bottom`,
      end: `bottom top`,
      scrub: true,
    },
  })
  tl.fromTo(
    refParallax.value,
    { y: `-${props.amount}%` },
    { y: `${props.amount}%`, ease: "none" }
  )

  return tl
}
const { init } = useScrollTrigger(createParallax)
watch(() => props.amount, init)

// **********************************************************************
// SCALE
// **********************************************************************
const updateScale = function () {
  refRoot.value.style.setProperty("--scale", props.scale)
  refRoot.value.style.setProperty(
    "--scalePercent",
    `${(props.scale - 1) * 100}%`
  )
}
onMounted(updateScale)
watch(() => props.scale, updateScale)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.parallax-image {
  overflow: hidden;
  --scale: 1.2;
  --scalePercent: 20%;

  &.relative {
    .parallax {
      width: fit-content;
      height: fit-content;
    }
    .scale {
      transform: scale(var(--scale));
    }
  }

  &.full {
    .parallax {
      @include fill;
    }

    .scale {
      position: absolute;
      width: calc(100% + var(--scalePercent));
      height: calc(100% + var(--scalePercent));
      top: calc(var(--scalePercent) * -0.5);
      left: calc(var(--scalePercent) * -0.5);
    }
  }
}
</style>
